import React from 'react';
import { useMediaQuery } from '@mui/material';
import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';
import getPlatformUrlByCountry from '../../helpers/getPlatformUrlByCountry';
import useGetCountry from '../../helpers/useGetCountry';
import { FINGO_BLOG_URL } from '../../constants/links';
import FingoLogo from '../../components/logo/FingoLogo';
import { isMexicoEnabled, useIsMexicoDisabled } from '../../helpers/featureFlags';

const platformUrl = getPlatformUrlByCountry();

const buttons = [
  {
    title: 'Iniciar sesión',
    url: `${platformUrl}/user-login`,
    variant: 'secondary',
    id: 'login',
  },
  {
    title: 'Registrarme',
    url: `${platformUrl}/user-register`,
    variant: 'newPrimary',
    id: 'register',
  },
];
const pages = [
  {
    title: 'Nuestros servicios',
    url: '/factoring',
    id: 'products',
    variant: 'dropDown',
  },
  {
    title: 'Nosotros',
    url: '/team',
    id: 'team',
    variant: 'navlink',
  },
  {
    title: 'Blog',
    url: () => window.open(FINGO_BLOG_URL, '_blank'),
    id: 'blog',
    variant: 'navlink',
  },
  {
    title: 'Preguntas frecuentes',
    url: '/faq',
    id: 'faq',
    variant: 'navlink',
  },
];

function DefaultNavbar() {
  const isMobile = useMediaQuery('(max-width: 1008px)');
  const country = useGetCountry();
  const isMexicoDisabled = useIsMexicoDisabled();
  const navButtons = isMexicoDisabled
    ? buttons.filter((button) => button.id !== 'register')
    : buttons;
  const countryPagesMapper = {
    Chile: pages,
    Mexico: pages.filter(
      (page) => page.title !== 'Blog' && (isMexicoEnabled || page.id !== 'faq'),
    ),
  };
  const navbarPages = countryPagesMapper[country];
  if (isMobile) return <MobileNavbar buttons={navButtons} pages={navbarPages} Logo={FingoLogo} />;
  return <DesktopNavbar buttons={navButtons} pages={navbarPages} Logo={FingoLogo} />;
}

export default DefaultNavbar;
